import React from 'react';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';
import { noop } from '../../../../utils/utils';

export default class CampaignBodyInput extends React.Component {
  static propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func,
  };

  static defaultProps = {
    value: '',
    onChange: noop,
  };

  render() {
    return (
      <TextField
        id="bodyInput"
        label="Body"
        value={this.props.value}
        onChange={this.props.onChange}
        margin="normal"
        helperText="This field allows multiple lines of input"
        multiline
        rowsMax={15}
        fullWidth
        required
      />
    );
  }
}
